var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isEURegion)?_c('TemplateLibraryGlobal'):_vm._e(),(_vm.isEURegion)?_c('TemplateLibraryEU'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }